import type { KnowledgeBaseSyncProvider } from "@repo/app-types/entities/knowledgeBaseSync";
import { KnowledgeBaseSyncProviderLogo } from "@repo/ui/knowledgeBaseSync/knowledgeBaseSyncProviderLogo";
import { format } from "date-fns";
import type { FC } from "react";

interface KnowledgeBaseSyncPillProps {
  provider: KnowledgeBaseSyncProvider;
  lastSyncedAt: string | null;
}

export const KnowledgeBaseSyncPill: FC<KnowledgeBaseSyncPillProps> = (
  props,
) => {
  const { provider, lastSyncedAt } = props;

  return (
    <div className="flex h-7 items-center gap-1.5 text-xs font-medium text-muted-foreground">
      <KnowledgeBaseSyncProviderLogo provider={provider} className="size-5" />
      {lastSyncedAt ? (
        <time dateTime={lastSyncedAt}>
          Last synced{" "}
          {format(new Date(lastSyncedAt), "MMM d, yyyy 'at' h:mm a")}
        </time>
      ) : (
        <span>Not synced yet</span>
      )}
    </div>
  );
};
